window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

/**
 * Helper functions to obtain toggle state information.
 *
 * @param {Object} cookie   The o_util.cookie object.
 *
 * @return {Object} Public methods of o_util.toggle.
 */
o_util.toggle = (function(cookie) {
    "use strict";

    var COOKIE_PREFIX = "toggle_";

    /**
     * Returns a boolean state for a toggle by checking
     * if globally or locally enabled.
     * The result will be false if both values are not available
     * and no default passed. Otherwise all teams
     * can pass a default boolean value to indicate if the
     * feature is enabled or not when a toggle is unavailable.
     * (For example: the toggle service is not reachable).
     *
     * @example
     *
     * var toggleValue = o_util.toggle.get("myAwesomeToggle");
     *
     * if (toggleValue) {
     *      // Toggle/feature is active
     * } else {
     *      // Toggle/feature is inactive or javascript toggle is undefined and no local cookie is set
     * }
     *
     * var toggleValue = o_util.toggle.get("myAwesomeToggle", true);
     *
     * if (toggleValue) {
     *      // Toggle/feature is active or javascript toggle is undefined and no local cookie is set
     * } else {
     *      // Toggle/feature is inactive
     * }
     *
     * @param {String}  toggleName      Name of toggle (o_global.toggles).
     * @param {Boolean} [defaultValue]  Specific return value of the function if toggle is unavailable.
     *
     * @return {Boolean}    Status of the toggle (true = ON, false = OFF).
     */
    function get(toggleName, defaultValue) {
        var localStatus = cookie.get(COOKIE_PREFIX + toggleName);

        if ((o_global.toggles && o_global.toggles[toggleName] === true) || localStatus === "true") {
            // GLOBAL: true, COOKIE: true -> ON
            // GLOBAL: true, COOKIE: false -> ON
            // GLOBAL: true, COOKIE: undefined -> ON
            // GLOBAL: false, COOKIE: true -> ON
            // GLOBAL: undefined, COOKIE: true -> ON
            return true;
        } else if ((o_global.toggles && o_global.toggles[toggleName] === false) || localStatus === "false") {
            // GLOBAL: false, COOKIE: undefined -> OFF
            // GLOBAL: false, COOKIE: false -> OFF
            // GLOBAL: undefined, COOKIE: false -> OFF
            return false;
        } else {
            // GLOBAL: undefined, COOKIE: undefined -> Default handling for teams
            return typeof defaultValue === "boolean" ? defaultValue : false;
        }
    }

    /**
     * Return public API.
     */
    return {
        "get": get
    };
}(o_util.cookie));
